import { RegisterOptions } from 'react-hook-form'

// limitation imposed by NS
export const ADDRESS_MAX_LENGTH = 150
export const COMPANY_NAME_MAX_LENGTH = 83
export const EMAIL_MAX_LENGTH = 254
export const FIRST_NAME_MAX_LENGTH = 32
export const LAST_NAME_MAX_LENGTH = 32
export const PHONE_MAX_LENGTH = 32
export const PHONE_MIN_LENGTH = 7

const maxLengthRuleFor = (maxLength: number): Pick<RegisterOptions, 'maxLength'> => {
  return {
    maxLength: {
      value: maxLength,
      message: `Length must not exceed ${maxLength} characters`,
    },
  }
}

const minLengthRuleFor = (minLength: number): Pick<RegisterOptions, 'minLength'> => {
  return {
    minLength: {
      value: minLength,
      message: `Length must be at least ${minLength} characters`,
    },
  }
}

export const addressMaxLengthRule = maxLengthRuleFor(ADDRESS_MAX_LENGTH)
export const companyNameMaxLengthRule = maxLengthRuleFor(COMPANY_NAME_MAX_LENGTH)
export const emailMaxLengthRule = maxLengthRuleFor(EMAIL_MAX_LENGTH)
export const firstNameMaxLengthRule = maxLengthRuleFor(FIRST_NAME_MAX_LENGTH)
export const lastNameMaxLengthRule = maxLengthRuleFor(LAST_NAME_MAX_LENGTH)
export const phoneMaxLengthRule = maxLengthRuleFor(PHONE_MAX_LENGTH)
export const phoneMinLengthRule = minLengthRuleFor(PHONE_MIN_LENGTH)
